import { render } from "./TipsView.vue?vue&type=template&id=255a541c"
import script from "./TipsView.vue?vue&type=script&lang=js"
export * from "./TipsView.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__